const PageReady = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.5 4.5A1.5 1.5 0 0 0 6 6v12a1.5 1.5 0 0 0 1.5 1.5h9A1.5 1.5 0 0 0 18 18V9.5h-2.5A2.5 2.5 0 0 1 13 7V4.5zM5 6a2.5 2.5 0 0 1 2.5-2.5h6a.5.5 0 0 1 .354.146l5 5A.5.5 0 0 1 19 9v9a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 5 18z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="m11.06 15.75 4.126-4.143a.48.48 0 0 1 .353-.14q.213 0 .354.138.14.14.14.354a.48.48 0 0 1-.14.355l-4.267 4.248a.78.78 0 0 1-.565.243.78.78 0 0 1-.566-.243l-2.388-2.369a.47.47 0 0 1-.14-.353q0-.214.138-.354a.48.48 0 0 1 .354-.14.48.48 0 0 1 .355.14z"
    />
  </>
)
export default PageReady
